/**
 * @description Statistics bar for the Recurring Plans tab.
 * Shows active count, MRR, ARR, upcoming revenue, and charges this week.
 *
 * @dependencies
 * - recurringPlanService: API client for statistics
 */

import { formatCurrency } from '../../utils/invoiceHelpers';

export default function RecurringStatistics({ statistics, loading }) {
  if (loading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-6">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="bg-white rounded-lg shadow p-4 animate-pulse">
            <div className="h-4 bg-gray-200 rounded w-20 mb-2" />
            <div className="h-6 bg-gray-200 rounded w-16" />
          </div>
        ))}
      </div>
    );
  }

  if (!statistics) return null;

  const stats = [
    {
      label: 'Active Plans',
      value: statistics.activeCount || 0,
      color: 'text-green-600'
    },
    {
      label: 'MRR',
      value: formatCurrency((statistics.mrrCents || 0) / 100),
      color: 'text-brand'
    },
    {
      label: 'ARR',
      value: formatCurrency((statistics.arrCents || 0) / 100),
      color: 'text-brand'
    },
    {
      label: 'Upcoming (30 days)',
      value: formatCurrency((statistics.upcomingRevenue30DaysCents || 0) / 100),
      color: 'text-gray-900'
    },
    {
      label: 'Charges This Week',
      value: statistics.upcoming7Days || 0,
      color: 'text-orange-600'
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-6">
      {stats.map((stat) => (
        <div key={stat.label} className="bg-white rounded-lg shadow p-4">
          <p className="text-sm text-gray-500">{stat.label}</p>
          <p className={`text-xl font-bold ${stat.color}`}>{stat.value}</p>
        </div>
      ))}
    </div>
  );
}
